import SectionHeading from '@/pages/home/components/SectionHeading';
import { aboutPoints } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="先弄清楚它是谁"
          title="神马影院，到底是一个什么样的存在"
          desc="在判断“好不好”之前，先了解这类站点的一般特征，会让你后面的判断更有依据。以下为同类第三方影视站点的常见情况。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-9">
          {aboutPoints.map((p) => (
            <div
              key={p.title}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <div className="flex items-start gap-4">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-background-50 border border-background-300 text-primary-600">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">{p.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-xs text-foreground-500 leading-relaxed max-w-3xl">
          说明：不同同名站点在片源、广告策略和运营方式上可能差异很大，以上为对“第三方影视聚合站”这一类产品的普遍描述，不代表某个具体站点的全部情况，请结合你实际遇到的情况判断。
        </p>
      </div>
    </section>
  );
}